/* Axios default-instance interceptor stub. Side-effect imported from index.tsx.
   On 401 the live build purges the persisted auth slice and returns to login;
   for the Slice-1 mock there is no server, so this only normalises errors. */
import axios from 'axios';

let installed = false;

export const installApiInterceptors = (): void => {
  if (installed) return;
  installed = true;
  axios.interceptors.response.use(
    (res) => res,
    (error) => {
      // Placeholder for 401 → signOut + persistor.purge() + redirect to '/'.
      return Promise.reject(error);
    },
  );
};

installApiInterceptors();
